import { Collapse, CollapseProps } from "antd";
import "./Accordion.scss";

interface AccordionItem {
  key: string;
  label: React.ReactNode;
  children: React.ReactNode;
}

interface AccordionProps extends Omit<CollapseProps, "items"> {
  items: AccordionItem[];
}

const Accordion: React.FC<AccordionProps> = ({
  items,
  className,
  ...rest
}) => {
  return (
    <Collapse
      className={["accordion", className].filter(Boolean).join(" ")}
      bordered={false}
      expandIconPosition="end"
      items={items}
      {...rest}
    />
  );
};

export default Accordion;
